import { Box, Button, Dialog, DialogContent, DialogTitle, Grid, Typography } from '@material-ui/core';
import { memo, useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { showMessage } from '../../../store/actions/messages.actions';
import { deviceWritePermission } from '../../../store/selectors/account.selector';
import store from '../../../store/store';
import { archiveDevice, setDevicesRefresh } from '../../../store/actions/devices.actions';
import formatPhone from '../../../utils/formatPhone';

function addressAndName(address, name) {
  return address + ', ' + name;
}

const DeviceDeleteDialog = ({ handleClose, ...props }) => {
  const dispatch = useDispatch();
  const { action1, actionId1 } = useParams();

  const editPermission = useSelector(deviceWritePermission);

  const devices = useSelector((state) => state.devices.list);
  const [deviceSelected, setDeviceSelected] = useState({});
  const [deleteDialog, setDeleteDialog] = useState(false);

  // state effect
  useEffect(() => {
    const deviceFromList = actionId1 && (devices.find((item) => item.id === actionId1));
    if (action1 === 'delete') {
      setDeleteDialog(true);
    } else if (deleteDialog) {
      setDeleteDialog(false);
    }
    if (action1 === 'delete' && actionId1) {
      setDeviceSelected({
        ...deviceFromList,
      });
    }
  }, [action1, actionId1, devices]);

  const onDeleteDevice = async () => {
    try {
      await store.dispatch(archiveDevice(actionId1));
      dispatch(showMessage({ open: true, text: 'Устройство успешно удалено', severity: 'success' }));
      handleClose(null, 'success');
      setTimeout(() => dispatch(setDevicesRefresh()), 500);
    } catch (error) {
      console.log(error);
      dispatch(showMessage({ open: true, text: `Не удалось удалить. ${error.message}`, severity: 'error' }));
    }
  };

  return (
    <>
      {/* delete dialog */}
      <Dialog {...props} open={deleteDialog} onClose={handleClose} disableRestoreFocus>
        <DialogTitle>
          <Box sx={{ fontSize: '22px' }}>
            Удалить устройство?
          </Box>
        </DialogTitle>
        <DialogContent sx={{ paddingBottom: '8px' }}>
          <Typography
            color="textSecondary"
            variant="body1"
          >
            <span>Устройство с адресом </span>
            <strong>{addressAndName(deviceSelected.address, deviceSelected.name)}</strong>
            <span> будет удалено</span>
          </Typography>
          <Grid
            container
            justifyContent="space-between"
            spacing={2}
            sx={{
              pb: 2,
              pt: 4,
            }}
          >
            <Grid
              item
            >
              <Button
                variant="contained"
                color="secondary"
                fullWidth
                onClick={handleClose}
              >
                Отменить
              </Button>
            </Grid>
            <Grid
              item
            >
              {editPermission && (
                <Button
                  variant="contained"
                  color="purple"
                  fullWidth
                  onClick={onDeleteDevice}
                >
                  Удалить
                </Button>
              )}
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  );
};

DeviceDeleteDialog.propTypes = {
  handleClose: PropTypes.func,
};

DeviceDeleteDialog.defaultProps = {
  handleClose: null,
};

export default memo(DeviceDeleteDialog);
